const baseUrl = 'https://livon-comforts-backend-117751779810.asia-south2.run.app/'
// const baseUrl = 'http://localhost:5000/'
export default baseUrl;
